(function ($) {
    
    var loadingIcon = '<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>';
    function submitForm(form, clickedBtn) {
        
        // create loading
        clickedBtn.attr('disabled', true).addClass('loading').append(loadingIcon);        
        if(typeof recaptcha_site_key_v3 !== 'undefined' && recaptcha_site_key_v3 !== undefined) {
            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha_site_key_v3,{
                    action: recaptcha_action
                }).then(function(token) {
                    if (token) {

                        form.find('[name="recaptcha"]').val(token);
                        form.find('#recaptcha-error').addClass('d-none');
                        var params = form.serialize();
                        var url = cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/' + form.data('service');
                        if (form.data('form-setup')) {
                            url +=  '/' + form.data('form-setup');
                        }
                        
                        $.ajax({													
                            method: 'POST',
                            url: url,
                            data: params									
                        }).done(function(e) {
                            // remove loading
                            clickedBtn.attr('disabled', false).removeClass('loading').find('i').remove();	
                            form.find('.has-error').removeClass('has-error');
                            form.find('.is-valid').removeClass('is-valid');
                            form.find('.captcha').removeClass('is-error');
                            form.find('.alert-danger').addClass('d-none');		
                            
                            if (e.success == false) {
                                $.each(e.invalid, function( index, errorName ) {
                                    if (errorName == "recaptcha") {                
                                        form.find('#recaptcha-error').removeClass('d-none');
                                    } else {
                                        form.find('[name="' + errorName + '"]').parent('.form-group').addClass('has-error'); 
                                    }
                                });                                
                                $.each(e.invalid_custom, function( index, errorName ) {
                                    form.find('.error-'+errorName).removeClass('d-none').show();
                                    return false;
                                });
                                $.each(e.valid, function( index, inputName ) {
                                    form.find('[name="' + inputName + '"]').addClass('is-valid'); 
                                });
                            // if success   
                            } else if (e.success == true) {    
                                if (e.redirect_url){
                                    window.location.replace(e.redirect_url);
                                } else {                                                    
                                    form.find('.form-body').hide();                  
                                    form.find('.form-success').removeClass('d-none').show();
                                }
                            } 
                        });
                    } else {
                        form.find('#recaptcha-error').removeClass('d-none');
                        form.find('.captcha').addClass('is-error');
                        return false;
                    }
                });
            });                
        }
    }
    
    // UNIVERSAL FORM
    $(document).on("click", '#formContactUserageda button', function(e) {
        e.preventDefault();
        submitForm($('#formContactUserageda'),$(this));
    });   
    
    // File uploading
    $(document).on("change", '.attachments', function(event) {
        if (event.target.files[0] !== undefined) {
            
            var files = [],
                filesArr = [],
                button = $(this),
                inputId = button.attr("id"),
                upload = $("#upload-" + inputId),
                accept = button.attr("accept").split(","),
                max_size = (button.attr("data-max-size") * 1048576),
                fileErrorMessage = upload.find(".fileErrorMessage"),
                fileUploading = upload.find(".fileUploading"),
                fileUploaded = upload.find(".fileUploaded"),
                data = new FormData(),
                isOk = true;
            
            upload.removeClass('has-error');
            fileErrorMessage.hide().find('span').text('');
            fileUploading.removeClass('d-none').show();
            $("#upload-" + inputId).find(".fileErrorMessage_type, .fileErrorMessage_missing, .fileErrorMessage_size").hide();
                        
            $.each(event.target.files, function (key, value) {
                
                var valid_ext = false;
                var current_ext = value.name.substr((value.name.lastIndexOf('.')));
                $.each(accept, function (key, type) {
                    console.log(current_ext +" == "+type); 
                    if (current_ext == type) {
                        valid_ext = true;
                    }
                });
                
                if (valid_ext) {
                    if (value.size <= max_size) {
                        data.append(key, value);
                    } else {                 
                        upload.parent('.form-group').addClass('has-error');
                        fileErrorMessage.removeClass('d-none').show();
                        upload.find(".fileErrorMessage_size").removeClass('d-none').show();
                        button.prop('disabled', false).parent().removeClass("disabled");
                        isOk = false;
                        fileUploading.hide();
                    }
                } else {
                    upload.parent('.form-group').addClass('has-error');
                    upload.find(".fileErrorMessage_type").removeClass('d-none').show();
                    button.prop('disabled', false).parent().removeClass("disabled");
                    isOk = false;
                    fileUploading.hide();                    
                }
            });

            if (isOk) {
                var sucessfull_upload = false;
                var uploaded = $.ajax({
                    url: cyclone3.domain + '/upload.pl',
                    type: 'POST',
                    data: data,
                    cache: false,
                    processData: false,
                    contentType: false,
                    dataType: "xml",
                    success: function (data) {
                        
                        if ($(data).find('error').length > 0) {
                        
                            var error = $(data).find('error').text();
                            if (error == "size") {
                                fileErrorMessage.removeClass('d-none').show();
                                upload.find(".fileErrorMessage_size").removeClass('d-none').show();
                                button.prop('disabled', false).parent().removeClass("disabled");
                                upload.parent('.form-group').addClass('error');
                            }                            
                            return false;
                        
                        } else if ($(data).find('file').length > 0) {
                        
                            $.each($(data).find('file'), function (key, value) {
                                files.push($(value).find('hash').text() + '/' + $(value).find('fullname').text());
                                filesArr.push($(value).find('fullname').text());
                            });
                            sucessfull_upload = true;
                        
                        } else {
                            
                            fileErrorMessage.removeClass('d-none').show();
                            button.prop('disabled', false).parent().removeClass("disabled");
                            upload.parent('.form-group').addClass('has-error');                    
                            return false;
                        }
                        
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log(xhr.status);
                        console.log(thrownError);
                        console.log(xhr.responseText);
                    }
                });
                
                $.when(uploaded).then(function () {
                    
                    fileUploading.hide();
                    
                    if (sucessfull_upload)
                    {
                        upload.parent('.form-group').removeClass('error');
                        fileUploaded.text('');
                        upload.find('input[type="hidden"]').val(files);
                        filesArr.map(function (fileItem, i) {
                            fileUploaded.removeClass('d-none').append('<p class="fs-14">' + fileItem +
                                '<span class="file-remove" data-input="' + inputId + '" data-id="' + i + '"> <i class="fa fa-times-circle"></i></span></p>');
                        });
                        fileUploaded.removeClass('d-none').show();
                        event.target.value = '';
                    }
                });
            }
        }
    });

    $(document).on('click', '.file-remove', function () {
        $('#fileUploaded_' + $(this).data("input")).addClass('d-none').html("");
        $('input[name="attachment_files_' + $(this).data("input") + '"]').val("");
        $('input#' + $(this).data("input")).prop('disabled', false).parent("label").removeClass("disabled");
    });

        
})(jQuery);